import React, { useEffect, useState } from 'react';
import "react-multi-carousel/lib/styles.css";
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getFavorites, softDeleteFavorite } from '../../Services/FavoriteService';
import { setAccessUrl, setCounter } from '../../Services/AssetService';
import Swal from 'sweetalert2';
import { saveAs } from "file-saver";
import { Lightbox } from "react-modal-image";
import { formatDateString, truncate } from '../../Utils/Utils';

const { $ } = window;
const AssetFavoritePage = () => {

    const navigation = useNavigate();
    const { userInfo } = useSelector(state => state.auth);
    const [state, setState] = useState({ 
        assets: [],
        setImageUrl: '',
        isOpen: false,
        setImageTitle: '',
        total_asset: 0,
        current_page: 1,
        total_page: 1,
        prev_page: null,
        next_page: null
    });

    const closeLightbox = () => {
        setState({ ...state, isOpen: false})
    };

    const openLightbox = (image, title) => {
        setState({ ...state, setImageUrl: image, setImageTitle: title, isOpen: true })
    };

    const onShowMoreClick = (data) => {
        setState({ ...state, current_page:  data});
    }
    const responsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 3
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 2
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    };

    const onBack = () => {
        navigation(-1);
    }

    const onAssetClick = id => () => {
        navigation('/asset/detail/' + id);
    }

    const fetchFavorite = (page, param = '') => {
        getFavorites({ page: page, perpage: 12, order: `created_on`, direction: `desc`, filterAnd: `is_active:true,user.username:${userInfo.username}${param}`}, ({ data }) => {
            setState({ 
                ...state, 
                assets: data.data, 
                subcategories: [],
                total_asset: data.total,
                total_page: data.total_page, 
                prev_page: data.prev_page, 
                next_page: data.next_page  
            });
        });
    }
    
    const deleteFavorite = (id) => {
        const body = {
            is_active: false
        }

        softDeleteFavorite(id, body, res => {
            if (res.status == 200 || res.status == 201) {
                Swal.fire({
                    icon: 'success',
                    title: 'Delete Asset from my favorite success',
                    text: res.message
                }).then(fetchFavorite(1));
            }
        }, error => {
            Swal.fire({
                icon: 'error',
                title: 'Delete Asset from my favorite fail',
                text: error.response.data.message
            });
            
        });
    }

    const saveFile = (id, param = 'std', index = 0) => {
        const body = {
            file: param,
            index: index,
            expired: 60
        }

        setAccessUrl(id, body, res => {
            if (res.status == 200 || res.status == 201) {
                saveAs(res.data.fileUrl, res.data.fileName );
                insertCounter(id, 'download');
            }
        }, error => {
            Swal.fire({
                icon: 'error',
                title: 'Share or download fail',
                text: 'Error sharing/download file'
            });
        });
    };

    const insertCounter = (id, param) => {
        const body = { status: param }

        setCounter(id, body, res => {
            if (res.status == 200 || res.status == 201) {console.log('counter', res.message)}
        }, error => {
            console.log('counter_error', error.response.data.message)
        });
    }

    const setDateFormat = param => {
        let date = '';
        date = param === undefined ?  '' : formatDateString(param);
        return date;
    }
    

    const { assets, setImageUrl, isOpen, setImageTitle, total_page, next_page, prev_page, current_page } = state;
    console.log('assets', assets)
    useEffect(() => {
        fetchFavorite(current_page)
    }, [current_page]);

    return (
        <div className='container'>
            <div onClick={onBack}  className='button_back' >
                <span className="fa fa-chevron-left" style={{ marginRight: 10 }}></span> <span> Back</span>
            </div>

            <div className='fav_title'>
                My Favorite
            </div>


            <div className='d-flex wrap_fav'>
                {
                    assets.map((item) => (
                        item.assetFile[0]?.is_active && item.assetFile[0]?.file && (
                            <div key={item._id} className=' item-list grid_item' >
                                <img src={process.env.REACT_APP_OBS_URL + item.asset_url} alt="" onClick={onAssetClick(item.asset_id)} />
                                <div className='wrap-card-overlay-2'>
                                    <div style={{ position: 'absolute', bottom: 10}}>
                                        <div className='card-text-title-16 card-text-overflow-16'>{item.assetFile[0].title}</div>
                                        {/* <div className='card-text-title-16'>{item.asset_date}</div> */}
                                        <div className="card-text-title-12">{setDateFormat(item.created_on)}</div>
                                    </div>
                                </div>
                                <div className='d-flex grid_item_action'>
                                    <div className='' style={{ flex: 2, marginRight: 6, marginLeft: 6 }}>
                                        <div className="">
                                            <button key={'clk_'+item.asset_id} type="button" className="btn btn-success d-flex justify-content-between align-items-center fav_success"
                                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" >
                                                <div className='flex-grow-1'>Action</div><span className="fa fa-caret-down"></span>
                                            </button>
                                            <div className="dropdown-menu" style={{ width: 200 }}>
                                                <div style={{ padding: 16, color: '#ccc' }}>File Type</div>
                                                {
                                                    item.assetFile[0].file.std?.size && !Array.isArray(item.assetFile[0].file.std) && (
                                                        <a className="dropdown-item" href="#" onClick={() => saveFile(item.asset_id, 'std')}>
                                                            <div className='d-flex justify-content-between align-items-center'>
                                                                <span>{(truncate(item.assetFile[0].file.std?.original_name.split('_')[1], 15) || '-')}</span>
                                                                <span style={{ fontSize: 12 }}>{(item.assetFile[0].file.std?.size || 0)}{(item.assetFile[0].file.std?.unit || '')}</span>
                                                            </div>
                                                        </a>
                                                    )
                                                }

                                                {
                                                    Array.isArray(item.assetFile[0].file.std) && item.assetFile[0].file.std.map ((obj, x) => (
                                                        <a key={'low_' + item.asset_id + x} className="dropdown-item" href="#" onClick={() => saveFile(item.asset_id, 'std', x)}>
                                                            <div className='d-flex justify-content-between align-items-center'>
                                                                <span>{(truncate(obj?.original_name.split('_')[1], 15) || '-')}</span>
                                                                <span style={{ fontSize: 12 }}>{(obj?.size || 0)}{(obj?.unit || '')}</span>
                                                            </div>
                                                        </a>
                                                    ))
                                                }

                                                {
                                                    item.assetFile[0].file.high?.size && !Array.isArray(item.assetFile[0].file.high) && (
                                                        <a key={'high_' + item.asset_id} className="dropdown-item" href="#" onClick={() => saveFile(item.asset_id, 'high')}>
                                                            <div className='d-flex justify-content-between align-items-center'>
                                                                <span>{(truncate(item.assetFile[0].file.high?.original_name.split('_')[1], 15) || '')}</span>
                                                                <span style={{ fontSize: 12 }}>(High) {item.assetFile[0].file.high?.size || 0}{(item.assetFile[0].file.high?.unit || '')}</span>
                                                            </div>
                                                        </a>
                                                    )
                                                }
                                                {
                                                    Array.isArray(item.assetFile[0].file.high) && item.assetFile[0].file.high.map((obj, x) => (
                                                        <a key={'high_' + item.asset_id + x} className="dropdown-item" href="#" onClick={() => saveFile(item.asset_id, 'high', x)}>
                                                            <div className='d-flex justify-content-between align-items-center'>
                                                                <span>{(truncate(obj?.original_name.split('_')[1], 15) || '')}</span>
                                                                <span style={{ fontSize: 12 }}>(High) {obj?.size || 0}{(obj?.unit || '')}</span>
                                                            </div>
                                                        </a>
                                                    ))
                                                }
                                                {
                                                    item.assetFile[0].file.low?.size && !Array.isArray(item.assetFile[0].file.low) && (
                                                        <a key={'low_' + item.asset_id} className="dropdown-item" href="#" onClick={() => saveFile(item.asset_id, 'low')}>
                                                            <div className='d-flex justify-content-between align-items-center'>
                                                                <span>{(truncate(item.assetFile[0].file.low?.original_name.split('_')[1], 15) || '')}</span>
                                                                <span style={{ fontSize: 12 }}>(Low) {item.assetFile[0].file.low?.size || 0}{(item.assetFile[0].file.low?.unit || '')}</span>
                                                            </div>
                                                        </a>
                                                    )
                                                }
                                                {
                                                    Array.isArray(item.assetFile[0].file.low) && item.assetFile[0].file.low.map((obj, x) => (
                                                        <a key={'low_' + item.asset_id + x} className="dropdown-item" href="#" onClick={() => saveFile(item.asset_id, 'low', x)}>
                                                            <div className='d-flex justify-content-between align-items-center'>
                                                                <span>{(truncate(obj?.original_name.split('_')[1], 15) || '')}</span>
                                                                <span style={{ fontSize: 12 }}>(Low) {obj?.size || 0}{(obj?.unit || '')}</span>
                                                            </div>
                                                        </a>
                                                    ))
                                                }
                                                {
                                                    item.assetFile[0].file.raw?.size && !Array.isArray(item.assetFile[0].file.raw) && (
                                                        <div>
                                                            <div className="dropdown-divider" />
                                                            <a key={'raw_' + item.asset_id} className="dropdown-item" href="#" onClick={() => saveFile(item.asset_id, 'raw')}>
                                                                <div className='d-flex justify-content-between align-items-center'>
                                                                    <span>{(truncate(item.assetFile[0].file.raw?.original_name.split('_')[1], 15) || '')}</span>
                                                                    <span style={{ fontSize: 12 }}>{item.assetFile[0].file.raw?.size || 0}{(item.assetFile[0].file.raw?.unit || '')}</span>
                                                                </div>
                                                            </a>
                                                        </div>
                                                    )
                                                }

                                                {
                                                    Array.isArray(item.assetFile[0].file.raw) && item.assetFile[0].file.raw.map((obj, x) => (
                                                        <div>
                                                            <div className="dropdown-divider" />
                                                            <a key={'raw_' + item.asset_id + x} className="dropdown-item" href="#" onClick={() => saveFile(item.asset_id, 'raw', x)}>
                                                                <div className='d-flex justify-content-between align-items-center'>
                                                                    <span>{(truncate(obj?.original_name.split('_')[1], 15) || '')}</span>
                                                                    <span style={{ fontSize: 12 }}>{obj?.size || 0}{(obj?.unit || '')}</span>
                                                                </div>
                                                            </a>
                                                        </div>
                                                    ))
                                                }

                                            </div>
                                        </div>
                                    </div>
                                    <div className='fav_action_btn'> 
                                        <button key={'del_'+item.asset_id} className="btn btn-danger" type='button' onClick={() => deleteFavorite(item._id)}><span className='fa fa-trash'></span></button>
                                    </div>
                                    <div className='fav_action_btn'>
                                        <button key={'src_'+item.asset_id} className="btn btn-primary" type='button' onClick={() => openLightbox(process.env.REACT_APP_OBS_URL + item.asset_url, item.assetFile[0].title)}><span className='fa fa-search-plus'></span></button>
                                    </div>
                                </div>
                            </div>
                        )
                    ))
                }
            </div>

            <div className='d-flex mt-5' style={{ justifyContent: 'center', alignItems: 'center', height: 54 }}>
                {
                    total_page > 1  && next_page != null && assets.length > 12 && (<button className="btn btn-lg btn-primary" type='button' onClick={() => onShowMoreClick(next_page)}>Next</button>)
                }
                {
                    total_page > 1  && prev_page != null && (<button className="btn btn-lg btn-primary" type='button' onClick={() => onShowMoreClick(prev_page)}>Back</button>)
                }
            </div>

            <div style={{ height: 64 }}></div>

            {
                isOpen && (
                    <Lightbox
                        large={setImageUrl}
                        alt={setImageTitle}
                        hideDownload={true}
                        hideZoom={true}
                        onClose={closeLightbox}
                    />
                )
            }
        </div>
    )
}


export default AssetFavoritePage;